<div class="chat_page_main_left">
  <div class="search_div">
    <img class="search_icon" src="/assets/images/search_icon.svg" alt="">
    <input type="text" placeholder="Search" [(ngModel)]="searchTerm" (ngModelChange)="filterOrders()">
    <img class="clear_icon" src="/assets/images/cloase-search.svg" alt="" (click)="searchTerm=''; filterOrders()">
  </div>


  <div class="chat_user_list">
    <p class="list_title">Product Order History</p>
    <div class="user_list_loop" *ngIf="productOrderHistory.length>0">
      <div #userCard class="user_card" [ngClass]="{
          'user_card_active': currentUserSelected?.id==item?.id,
          'user_unread_msg':item?.unreadCountClient>0
        }" *ngFor="let item of productOrderHistory" (click)="selectUser(item)">
        <div class="profile_pic">
          <img class="user_img" src="/assets/images/featuretallent.svg"
            onerror="this.src='/assets/images/featuretallent.svg'" alt="">
          <img class="avb_icon" src="/assets/avb_green.svg" alt="">
        </div>
        <div class="user_card_middle">
          <a class="user_name">{{item?.orderDetails?.consultantName?item?.orderDetails?.consultantName:'N/A'}}</a>
          <p class="last_msg_text job_title">{{item?.orderDetails?.productName}}</p>
          <!-- <p class="last_msg_text">Tax payment</p> -->
        </div>
        <div class="user_card_right">
          <!-- <div class="dot_img">
              <img src="/assets/images/card_view_drop.svg" alt="">
  
              <div class="close_option_dropdown">
                <p>Close</p>
              </div>
            </div> -->
          <p class="last_seen_time">{{item?.orderDetails?.creationTime | date:'dd MMM, yyyy'}}</p>
        </div>
        <div class="unread_count" *ngIf="item?.unreaddCount>0">
          <p>{{item?.unreaddCount}}</p>
        </div>
      </div>
    </div>
    <div class="no_user_list user_list_web" *ngIf="productOrderHistory?.length==0">
      <p>You have no pending orders</p>
    </div>
  </div>
</div>